import React from 'react';
import styled from 'styled-components';
import { getDurationFromMilliseconds } from '@ubeya/shared/utils/time';
import { FlexColumn, SmallBody } from '@ubeya/shared-web/components';

const Wrapper = styled(FlexColumn)`
  position: relative;

  > ${SmallBody} {
    ${({ isHeader }) => isHeader && 'font-weight: 500;'};
    color: ${({ $isError, theme }) => $isError && theme.colors.redNegative};
  }
`;

const DifferenceRenderer = ({ rowData: { subRows, difference } }) => {
  if (!difference) {
    return null;
  }

  const isError = Math.abs(difference) > 30 * 60 * 1000;

  return (
    <Wrapper isHeader={!!subRows} $isError={isError}>
      <SmallBody>{getDurationFromMilliseconds(difference, true)}</SmallBody>
    </Wrapper>
  );
};

export default DifferenceRenderer;
